import React from 'react';
import { Icon } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';
import TextBadge from '../../../components/TextBadge';
import styles from './HtmlList.module.less';

const HtmlList = ({ ecmContent }) => {
  const { list = [], contentJson = {} } = ecmContent || {};

  return (
    <div className={`${styles.checkout_options_list}`}>
      {list.map(({ content }, index) => (
        <div key={index} className={`${styles.checkout_list}`}>
          {contentJson && contentJson?.icon ? (
            <Icon name={contentJson.icon.name} color={contentJson.icon.color} />
          ) : (
            <TextBadge text={index + 1} />
          )}
          <div className={`${styles.text}`} dangerouslySetInnerHTML={{ __html: content }} />
        </div>
      ))}
    </div>
  );
};

HtmlList.propTypes = {
  ecmContent: PropTypes.object.isRequired
};

export default HtmlList;
